import {Component} from 'react';
import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux';
import MessagesList from './messages-list';
import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor'
import { getMessages } from '../../actions/messages'
import { loadPageContent } from '../../actions/content';

import './styles.css'

const PAGE_SLUG_MY_MESSAGES = 'my-messages';

class MyMessages extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showRead:   true,
      showUnread: true
    }
  }

  componentWillMount() {
    this.props.dispatch(getMessages());
    this.props.dispatch(loadPageContent(`api/pages/${PAGE_SLUG_MY_MESSAGES}`));
  }

  onFilterChanged = (filter, value) => {
    this.setState({[filter]: value}, () => {
      const {showRead, showUnread} = this.state;
      let read = undefined;

      if (!showRead) {
        if (showUnread) {
          read = 0;
        }
      } else if (!showUnread) {
        read = 1;
      }

      this.props.dispatch(getMessages(read));
    });
  };

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${PAGE_SLUG_MY_MESSAGES}`));
  };

  render() {
    return (
      <Grid bsClass="container" className="my-messages wrapper">
        <Row>
          <Col lg={12} className="spacing-0">
            <PageTitle>My messages</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="spacing-0">
            <InlineCKEditor
              identifier={`${PAGE_SLUG_MY_MESSAGES}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={this.props.contents[`${PAGE_SLUG_MY_MESSAGES}_content_text`]}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <MessagesList
              messages={this.props.messages}
              fetching={this.props.fetching}
              fetched={this.props.fetched}
              showRead={this.state.showRead}
              showUnread={this.state.showUnread}
              onFilterChanged={this.onFilterChanged}/>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    messages: state.messages.messages,
    fetched:  state.messages.fetched,
    fetching: state.messages.fetching,
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(MyMessages);



// WEBPACK FOOTER //
// ./src/components/my-messages/index.jsx